import { getWhisper } from './whisperApi';
import { whenDebug } from './debugUtils';

type ReportOptions = Record<string, any> & {
  level?: 'error' | 'warning' | 'info' | 'debug';
};

/**
 * Creates a reporter instance with a prefix for error tracking
 * @param prefix - The prefix to prepend to all messages (e.g., '[my-module]')
 * @returns A reporter object with captureError and captureMessage methods
 */
export const createReporter = (prefix: string) => {
  return {
    captureError: (
      message: string,
      error: any,
      options?: ReportOptions
    ): void => {
      const whisper = getWhisper();
      const prefixedMessage = `${prefix} ${message}`;
      whisper?.captureError?.(prefixedMessage, error, options);
      // eslint-disable-next-line no-console
      whenDebug(() => console.error(prefixedMessage, error));
    },
    captureMessage: (message: string, options?: ReportOptions): void => {
      const whisper = getWhisper();
      const prefixedMessage = `${prefix} ${message}`;
      whisper?.captureMessage?.(prefixedMessage, options);
      // eslint-disable-next-line no-console
      whenDebug(() => console.error(prefixedMessage));
    },
  };
};
